export default __webpack_public_path__ + "static/media/menu.80370d60.svg";